'use strict';

angular.module('admin').controller('AdminChargeUserController',
	['$scope', 'AdminData', 'Authentication', 'Utilities', '$stateParams', '$window',
		function($scope, AdminData, Authentication, Utilities, $stateParams, $window) {
			// $scope.authentication = Authentication;
			$scope.data = {
				userId: $stateParams.userId,
				amount: '',
				description: 'APPLANGA....*TRANSLATE'
			};

			$scope.processing = false;


			/**
			 * Load all the data
			 */
			$scope.init = function() {

				AdminData.userInfo({userId: $scope.data.userId}, function (userInfo) {
					$scope.data.userInfo = userInfo;
				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading user info',
						'error'
					);
				});

			};


			/**
			 * Charges the user the defined amount
			 */
			$scope.chargeUser = function() {

				// Check if the amount is valid
				if (!$scope.data.amount || isNaN($scope.data.amount) || parseInt($scope.data.amount) === 0) {
					// If there is no amount there is nothing to do

					Utilities.showMessage(
						'Problem!',
						'Please make sure that the entered amount is a number!',
						'error'
					);

					return;
				}

				$scope.processing = true;

				var sendData = {
					userId: $scope.data.userId,
					amount: $scope.data.amount
				};

				if ($scope.data.description && $scope.data.description.trim()) {
					// add the description if provided
					sendData.description = $scope.data.description.trim();
				}

				// Send the new data to server
				AdminData.chargeUser(sendData, function (returnData) {

					$scope.processing = false;

					Utilities.showMessage(
						'Success',
						'The amount got charged',
						'success',
						function() {
							// All fine
						}
					);


				}, function (error) {
					var errorMessage = 'There was a problem charging the user!';
					if (error.data && error.data.message) {
						errorMessage = 'There was a problem: <br />' + error.data.message;
					}

					$scope.processing = false;

					Utilities.showMessage(
						'Problem!',
						errorMessage,
						'error'
					);
				});
			};



			$scope.init();
		}
	]);
